import { get, post, put, httpDelete, urlConfig } from '../utils/request'
import {getCookie} from "../utils/common";
import node_env from "../node_env";

let preUrl = 'https://store-test.smartz.cloud'

if(node_env === 'production'){
  preUrl = 'https://houtai.smartz.cloud'
}

// 获取订单列表
export function getSubscribePriceList(data) {
  const url = preUrl + '/subscribe/plan'
  return get(url, {})
}

// 获取订单列表
export function getOrderList(){
  let user_token = getCookie('token');
  const url = `${preUrl}/order/list/${user_token}`;

  return get(url, {})
}

// 获取订单详情信息
export function getOrderDetail(order_id){
  let user_token = getCookie('token');
  const url = `${preUrl}/order/info/${order_id}/${user_token}`;

  return get(url, {})
}

// 激活订单
export function activateOrder(data){
  const url = `${preUrl}/order/activate`;
  // const url = `${preUrl}/order/activate/session`;
  return put(url, data)
}



// WEBPACK FOOTER //
// ./src/api/order.js